import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { backArrow } from '../../../../assets/images';
import { dsButtonLink, dsButtonPrimary, joinButtonClasses } from '../../../../utils/buttonStyles';

const MFAConfirmation = ({ continueMFA = () => {}, skipMFA }) => {
  let history = useHistory()
  const role = ['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role'))

  return(
    <div className=' mt-12'>
      <img src={backArrow} onClick={() => { window.location.reload() }} className='mb-3.5 cursor-pointer'/>
      <h1 className='font-fig-extrabold text-xl font-medium leading-8 text-gray-900 mb-0'>Secure your account</h1>
      <p className='text-base text-gray-600 mt-6 mr-20 mb-0 w-2/3'>
          You are required to enroll in Multi-Factor Authentication (MFA) for a extra layer of protection for your account.
      </p>
      <p className='text-base text-gray-600 mt-8 mr-20 mb-0 w-96'>
          Enroll using Google Authenticator or Authy app.
      </p>
      <button
      className={joinButtonClasses(dsButtonPrimary, 'mt-12 h-12 w-96')}
      onClick={continueMFA }
      >
      Continue
      </button>
      { !role &&
        <div
        onClick={(e) => skipMFA(e, 'mfaSkip')}
        className={joinButtonClasses(dsButtonLink, 'mb-0 mt-6 w-max text-gray-600 hover:text-blue-800')}
        style={{marginLeft : '181px'}}
        >
          Skip
      </div>}
    </div>
  )

}

export default MFAConfirmation;
